import { TAccountType, TCurrency } from 'api/unions'
import { number, type } from 'io-ts'

export const TDebt = type({
  amount: number,
  currency: TCurrency,
  accountType: TAccountType,
})
